module.exports = __webpack_public_path__ + "img/electronic_enabled_selected.7c492641.svg";